var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM432 416c0 26.47-21.53 48-48 48H64c-26.47 0-48-21.53-48-48V96c0-26.47 21.53-48 48-48h320c26.47 0 48 21.53 48 48V416zM316.7 256H272V152C272 138.7 261.3 128 248 128h-48C186.7 128 176 138.7 176 152V256H131.3C109.9 256 99.23 281.9 114.3 296.1l92.68 92.68C211.7 394.3 217.9 396.7 224 396.7s12.28-2.344 16.97-7.029l92.68-92.68C348.8 281.9 338.1 256 316.7 256zM322.3 285.7l-92.68 92.68C227.6 380.4 225.2 380.7 224 380.7s-3.617-.3047-5.656-2.344L125.7 285.7C122.2 282.2 123.3 278.4 123.9 276.9C124.5 275.5 126.5 272 131.3 272H192V152C192 147.6 195.6 144 200 144h48C252.4 144 256 147.6 256 152V272h60.68c4.824 0 6.777 3.453 7.393 4.938C324.7 278.4 325.8 282.2 322.3 285.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareDown);
export default __webpack_public_path__ + "static/media/square-down.0eca1fe7a655a5156b1cfe3b1f228251.svg";
export { ForwardRef as ReactComponent };